import React from 'react';
import { PoseGroup } from 'react-pose';
import './personal_training_edit.scss';
import {FadeContainer} from '../utils/pose_containers';
import PreLoader from '../utils/preloader';
import * as routes from '../constants';
import {DEFAULT_UNKNOWN_ERROR_MESSAGE} from '../constants';
import DefaultMenuLayout from '../components/default_menu_layout';
import {getModel, patchModel, postModel, getAsLocalDate} from '../utils/functions';
import DefaultMenuButton from '../components/default_menu_button';
import {HorizontalRule} from '../utils/default_section';
import WarningMessage from '../components/warning_message';
import DefaultInput, {HalfWrapper, SelectOption} from '../utils/default_input';
import OverlayWindow from '../components/overlay_window';
import ConfirmationWindow from '../components/confirmation_window';


const DIFFUCULTY_OPTION_EASY = 'Adaptado';
const DIFFUCULTY_OPTION_NORMAL = 'Normal';
const DIFFUCULTY_OPTION_INTERMEDIATE = '*';
const DIFFUCULTY_OPTION_ADVANCED = 'AV';

class PersonalTrainingEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      training_data: null,
      prExerciseAssociations: [],
      showStudentPr: null,
      studentOverlayReferenceData: null,
      studentOverlayOriginalReferenceData: null,
      studentOverlayShowInputs: false,
      highlights: [],
      warningMessage: "",
      showWarningMessage: false,
      supportTableVisible: false,
      onUpdateStudentReference: false,
      confirmInProgress: false,
      confirmFailed: false,
      confirmFailDescription: "",
      screenWidth: window.innerWidth,
    };
  }

  updateSize() {
    this.setState({
      screenWidth: window.innerWidth
    });
  }

  async getPersonalTrainingData() {
    return await getModel(`${routes.PERSONAL_TRAINING_DATA_GET_API}${this.props.match.params.personalTrainingId}`);
  }

  async componentDidMount() {
    const update = {loading: false};

    let data = this.getPersonalTrainingData();

    data = await data;

    if(data) {
      update.training_data = data;

      const exercise_associations = data.training_day.group_associations.flatMap((group) => group.exercise_associations);
      update.prExerciseAssociations = exercise_associations.filter((association) => association.difficult_name === 'PR');
    }

    this.setState(update);

    this.resizeListener = () => this.updateSize();

    window.addEventListener("resize", this.resizeListener);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeListener);
  }

  handleInputChange(event) {
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    let name = target.name;

    if(name === 'minutes') {
      const totalSeconds = this.state.training_data.total_seconds || 0;

      if(value !== null) {
        value = (parseInt(value)*60) + (totalSeconds % 60);
      }

      name = 'total_seconds';
    }
    else if(name === 'seconds') {
      const totalSeconds = this.state.training_data.total_seconds || 0;

      if(value !== null) {
        value = parseInt(value) + (Math.floor(totalSeconds / 60)*60);
      }

      name = 'total_seconds';
    }
    else if(name === 'workoutMinutes') {
      const totalSeconds = this.state.training_data.workout_time || 0;

      if(value !== null) {
        value = (parseInt(value)*60) + (totalSeconds % 60);
      }

      name = 'workout_time';
    }
    else if(name === 'workoutSeconds') {
      const totalSeconds = this.state.training_data.workout_time || 0;

      if(value !== null) {
        value = parseInt(value) + (Math.floor(totalSeconds / 60)*60);
      }

      name = 'workout_time';
    }

    const newData = {...this.state.training_data, [name]: value};

    this.setState({
      training_data: newData
    });
  }

  onSetPse(value) {
    const newData = {...this.state.training_data, pse: value};

    this.setState({
      training_data: newData
    });
  }

  inputsAreValid() {
    return this.state.training_data && this.state.training_data.date.length > 0;
  }

  async saveData() {
    if(!this.state.training_data.difficulty) {
      this.setState({
        highlights: ['difficulty'],
        showWarningMessage: true,
        warningMessage: "Dificuldade não selecionada"
      });

      return;
    }

    this.setState({
      highlights: [],
      showWarningMessage: false,
      loading: true
    });

    const data = {...this.state.training_data}
    data.difficulty = data.difficulty || null;
    data.pse = parseInt(data.pse);
    data.total_repetitions = parseInt(data.total_repetitions);
    data.total_seconds = parseFloat(data.total_seconds);
    data.workout_time = parseFloat(data.workout_time);
    data.total_weight = parseFloat(data.total_weight);

    try {
      await patchModel(`${routes.PERSONAL_TRAINING_DATA_PATCH_API}${this.props.match.params.personalTrainingId}`, data);
    }
    catch(errors) {
      let warningMessages = [];
      let highlights = [];

      if(errors instanceof Array) {
        for(let error of errors) {
          switch (error.code) {
            case 102:
              for(let parameter of error.parameters) {
                switch (parameter.name) {
                  case 'date':
                    warningMessages.push('Data inválida. Data cadastrada não pode ser nem no futuro e nem mais do que 28 dias atrás');
                    highlights.push('date');

                    break;
                  default:
                }
              }

              break;
            case 209:
              warningMessages.push('Sessão do usuário expirada');

              break;
            default:
          }
        }
      }

      if(warningMessages.length <= 0) {
        warningMessages.push(DEFAULT_UNKNOWN_ERROR_MESSAGE);
      }

      this.setState({
        highlights: highlights,
        showWarningMessage: true,
        warningMessage: `${warningMessages.join('; ')}.`,
        loading: false
      });

      return;
    }

    this.props.history.goBack();
    // this.props.history.replace(routes.TRAININGS_PATH);
  }

  hasSupportTable() {
    if(!this.state.training_data || !this.state.training_data.training_day) {
      return false;
    }

    return this.state.training_data.training_day.group_associations.some((association) => association.has_support_table);
  }

  getSupportTables() {
    const filteredAssociations = this.state.training_data.training_day.group_associations.filter((association) => association.has_support_table);

    return filteredAssociations.map((association) => {
      const rows = association.support_table.map((row, index) => (
        <div
          className="personal-training-edit__support-table__table__row-wrapper"
          key={`training_day_group_association:${association.id}:support_table:row:${index}`}
        >

          <p className="personal-training-edit__support-table__table__cell">
            {row[0]}
          </p>

          <p className="personal-training-edit__support-table__table__cell">
            {row[1]}
          </p>

        </div>
      ));

      return (
        <div
          className="personal-training-edit__support-table__table"
          key={`training_day_group_association:${association.id}:support_table`}
        >

          <div className="personal-training-edit__support-table__table__header">

            <h3 className="personal-training-edit__support-table__table__title">
              {association.name}
            </h3>

          </div>

          <div className="personal-training-edit__support-table__table__row-wrapper">

            <p className="personal-training-edit__support-table__table__column-label">
              Nº Série
            </p>

            <p className="personal-training-edit__support-table__table__column-label">
              Repetições
            </p>

          </div>

          {rows}

        </div>
      );
    });
  }

  handleKeyDown(event) {
    if(event.keyCode === 13 && this.inputsAreValid()) {
      this.saveData();
    }
  }

  isHighlighted(propertyName) {
    return this.state.highlights.includes(propertyName);
  }

  getDifficultyOptions() {
    const options = [
      DIFFUCULTY_OPTION_EASY,
      DIFFUCULTY_OPTION_NORMAL,
      DIFFUCULTY_OPTION_INTERMEDIATE,
      DIFFUCULTY_OPTION_ADVANCED,
    ];

    return [
      SelectOption('', 'Selecione uma dificuldade'),
      ...options.map((option) => SelectOption(option, option))
    ];
  }

  getStudentOverlayActions() {
    let addSaveAction = false;

    if(this.state.studentOverlayReferenceData !== null && this.state.studentOverlayOriginalReferenceData !== null) {
      for(let association of this.state.prExerciseAssociations) {
        if(this.state.studentOverlayReferenceData[association.exercise_id].value !== this.state.studentOverlayOriginalReferenceData[association.exercise_id].value) {
          addSaveAction = true;
        }
      }
    }

    return (
      <React.Fragment>

        <DefaultMenuButton
          className="personal-training-edit__overlay__action-button"
          onClick={() => this.setState({
            showStudentPr: false,
            studentOverlayReferenceData: null,
            studentOverlayOriginalReferenceData: null,
          })}
          text="Fechar"
          disabled={this.state.onUpdateStudentReference}
        />

        {addSaveAction &&
          <DefaultMenuButton
            className="personal-training-edit__overlay__action-button"
            onClick={() => this.setState({onUpdateStudentReference: true})}
            text="Salvar"
            color="green"
            disabled={this.state.onUpdateStudentReference}
          />
        }

      </React.Fragment>
    );
  }

  getStudentOverlayData() {
    if(this.state.studentOverlayReferenceData === null) {
      return null;
    }

    return this.state.prExerciseAssociations.map((association) => {
      const prValue = this.state.studentOverlayReferenceData[association.exercise_id].value;

      const normalMaxPercentage = association.difficult_value[0];
      let maxPercentage = normalMaxPercentage;
      let minPercentage = normalMaxPercentage - 30;

      const prPercentage = this.getPrPercentage(10, normalMaxPercentage);

      if(association.difficult_intermediate_value) {
        const intermediateMaxPercentage = association.difficult_intermediate_value[0];

        if(intermediateMaxPercentage > 0) {
          maxPercentage = Math.max(intermediateMaxPercentage, maxPercentage);
          minPercentage = Math.min(intermediateMaxPercentage - 30, minPercentage);
        }
      }

      if(association.difficult_advanced_value) {
        const advancedMaxPercentage = association.difficult_advanced_value[0];

        if(advancedMaxPercentage > 0) {
          maxPercentage = Math.max(advancedMaxPercentage, maxPercentage);
          minPercentage = Math.min(advancedMaxPercentage - 30, minPercentage);
        }
      }

      let prText = '';

      // if(prValue) {
      //   prText = prValue*prPercentage*0.01;
      //
      //   prText *= 1000;
      //   prText = Math.round(prText);
      //   prText = prText / 1000;
      // }

      const percentageGraduation = [];

      minPercentage = Math.max(minPercentage, 0);

      const step = Math.ceil((maxPercentage - minPercentage) / 6);
      minPercentage = maxPercentage - (6*step);

      const percentageReference = (Math.floor(((prPercentage - minPercentage) / step))*step) + minPercentage;

      if(!this.state.studentOverlayShowInputs) {
        const resistanceEntries = [];
        const hypertrophyEntries = [];
        const strengthEntries = [];

        for(let percentage=maxPercentage; percentage >= minPercentage; percentage -= step) {
          if(percentage < 0) {
            break;
          }

          if(prValue) {
            prText = prValue*percentage*0.01;

            prText *= 10;
            prText = Math.round(prText);
            prText = prText / 10;
          }

          const entry = (
            <div
              className={`personal-training-edit__overlay__reference__input-container${percentage === percentageReference ? '--selected' : ''}`}
              key={`edit_default_training:exercise_reference:${association.id}:pr_output:${percentage}`}
            >

              <p className="personal-training-edit__overlay__reference__pr-input-header">
                <span className="personal-training-edit__overlay__reference__input-prefix--highlighted">{percentage.toFixed(0)}%</span>
              </p>

              <DefaultInput
                className="personal-training-edit__overlay__reference__input"
                name={`exercise_reference:${association.id}`}
                type="number"
                placeholder="-"
                min="0"
                step="0.1"
                handleInputChange={(event) => this.handleReferenceChange(event)}
                value={prText}
                autoComplete="off"
                suffix="kg"
                onFocus={(event) => event.target.select()}
                disabled={true}
              />

            </div>
          );

          if (percentage < 60) {
            resistanceEntries.push(entry);
          }
          else if (percentage < 85) {
            hypertrophyEntries.push(entry);
          }
          else {
            strengthEntries.push(entry);
          }
        }

        if (strengthEntries.length > 0) {
          percentageGraduation.push(
            <div
              className="class-board__student-panel__pr-section__reference__input-group-container"
              key={`class_board:exercise_reference:${association.id}:pr_output_group:strength`}
            >

              <div className="class-board__student-panel__pr-section__reference__input-group-container__title-wrapper--strength">

                <p className="class-board__student-panel__pr-section__reference__input-group-container__title">Força</p>

              </div>

              <div className="class-board__student-panel__pr-section__reference__percentages-wrapper">

                {strengthEntries}

              </div>

            </div>
          );
        }
        if (hypertrophyEntries.length > 0) {
          percentageGraduation.push(
            <div
              className="class-board__student-panel__pr-section__reference__input-group-container"
              key={`class_board:exercise_reference:${association.id}:pr_output_group:hypertrophy`}
            >

              <div className="class-board__student-panel__pr-section__reference__input-group-container__title-wrapper--hypertrophy">

                <p className="class-board__student-panel__pr-section__reference__input-group-container__title">Hipertrofia</p>

              </div>

              <div className="class-board__student-panel__pr-section__reference__percentages-wrapper">

                {hypertrophyEntries}

              </div>

            </div>
          );
        }
        if (resistanceEntries.length > 0) {
          percentageGraduation.push(
            <div
              className="class-board__student-panel__pr-section__reference__input-group-container"
              key={`class_board:exercise_reference:${association.id}:pr_output_group:resistance`}
            >

              <div className="class-board__student-panel__pr-section__reference__input-group-container__title-wrapper--resistance">

                <p className="class-board__student-panel__pr-section__reference__input-group-container__title">Resistência</p>

              </div>

              <div className="class-board__student-panel__pr-section__reference__percentages-wrapper">

                {resistanceEntries}

              </div>

            </div>
          );
        }
      }

      let updatedAtText = null;

      if(this.state.studentOverlayReferenceData[association.exercise_id].updated_at) {
        const today = getAsLocalDate((new Date()).toISOString().slice(0, 10));
        const updatedAt = getAsLocalDate(this.state.studentOverlayReferenceData[association.exercise_id].updated_at.slice(0, 10));

        const timeDiff = Math.abs(today.getTime() - updatedAt.getTime());
        let daysCount = Math.ceil(timeDiff / (1000 * 3600 * 24));

        updatedAtText = `Salvo em ${updatedAt.toLocaleDateString()} (${daysCount} dia(s))`;
      }

      return (
        <div
          key={`student:${this.state.training_data.id}:exercise_reference:${association.id}`}
          className="personal-training-edit__overlay__reference"
        >

          {updatedAtText !== null &&
            <p className="personal-training-edit__overlay__reference__date-text">

              {updatedAtText}

            </p>
          }

          <div className="personal-training-edit__overlay__reference__wrapper">

            <h4 className="personal-training-edit__overlay__reference__label">{association.exercise_name}:</h4>

            {!this.state.studentOverlayShowInputs ?
              <div className="personal-training-edit__overlay__reference__percentages-wrapper">

                {percentageGraduation}

              </div>:
              <div className="personal-training-edit__overlay__reference__input-container--horizontal">

                <div className="personal-training-edit__overlay__reference__pr-input-wrapper">

                  <DefaultInput
                    key={`class_board:exercise_reference:${association.id}:weight`}
                    className="personal-training-edit__overlay__reference__input--extended"
                    name={`exercise_reference_input:${association.id}:weight`}
                    type="number"
                    placeholder="-"
                    min="0"
                    step="0.1"
                    handleInputChange={(event) => this.handleReferenceChange(event)}
                    value={this.state.studentOverlayReferenceData[association.exercise_id].weight || ''}
                    autoComplete="off"
                    suffix="kg"
                    prefix="Peso"
                    onFocus={(event) => event.target.select()}
                  />

                  <DefaultInput
                    key={`class_board:exercise_reference:${association.id}:repetition`}
                    className="personal-training-edit__overlay__reference__input--extended"
                    name={`exercise_reference_input:${association.id}:repetition`}
                    type="number"
                    placeholder="-"
                    min="0"
                    step="1"
                    handleInputChange={(event) => this.handleReferenceChange(event)}
                    value={this.state.studentOverlayReferenceData[association.exercise_id].repetition || ''}
                    autoComplete="off"
                    prefix="Repetições"
                    onFocus={(event) => event.target.select()}
                  />

                </div>

                {(this.state.studentOverlayReferenceData[association.exercise_id].repetition && this.state.studentOverlayReferenceData[association.exercise_id].weight) &&
                  <React.Fragment>

                    <i className="fas fa-long-arrow-alt-right personal-training-edit__overlay__reference__arrow-icon"></i>

                    <p className="personal-training-edit__overlay__reference__pr-text">

                      (<b>100%</b> do PR: <b>{prValue.toFixed(0)}</b> kg)

                    </p>

                  </React.Fragment>
                }

              </div>
            }

          </div>

        </div>
      );
    });
  }

  onShowStudentPr() {
    const exercise_ids = this.state.prExerciseAssociations.map((association) => association.exercise_id);

    const studentOverlayReferenceData = {};

    for(let id of exercise_ids) {
      studentOverlayReferenceData[id] = this.state.training_data.exercise_reference[id];
    }

    this.setState({
      studentOverlayReferenceData,
      showStudentPr: true,
      studentOverlayShowInputs: false,
      studentOverlayOriginalReferenceData: {...studentOverlayReferenceData},
    });
  }

  getConfirmationWindowTitle() {
    if(this.state.confirmFailed) {
      if(this.state.onUpdateStudentReference) {
        return 'Falha ao salvar dados de PR de aluno';
      }
    }
    else if(this.state.confirmInProgress) {
      if(this.state.onUpdateStudentReference) {
        return 'Salvando dados';
      }
    }
    else {
      if(this.state.onUpdateStudentReference) {
        return 'Salvar dados de PR';
      }
    }

    return 'Não implementado';
  }

  getConfirmationWindowDescription() {
    if(this.state.confirmFailed) {
      return this.state.confirmFailDescription;
    }
    if(this.state.onUpdateStudentReference) {
      return `Deseja realmente atualizar os dados de PR do aluno?`;
    }

    return 'Não implementado';
  }

  getConfirmationWindowConfirmButtonText() {
    if(this.state.onUpdateStudentReference) {
      return `Salvar dados`;
    }

    return 'Não implementado';
  }

  confirmationWindowIsVisible() {
    return this.state.onUpdateStudentReference === true;
  }

  resetConfirmationWindow() {
    this.setState({
      onUpdateStudentReference: false,
      confirmFailed: false,
      confirmInProgress: false,
    });
  }

  async proceedConfirmationWindow() {
    if(this.state.onUpdateStudentReference) {
      this.setState({
        confirmInProgress: true
      });

      const data = {reference_data: []};

      const referenceCopy = {...this.state.studentOverlayReferenceData};
      const todayIso = (new Date()).toISOString().slice(0, 10);

      for(let association of this.state.prExerciseAssociations) {
        referenceCopy[association.exercise_id].updated_at = todayIso;

        data.reference_data.push({
          exercise_id: association.exercise_id,
          value: parseFloat(referenceCopy[association.exercise_id].value),
          weight: parseFloat(referenceCopy[association.exercise_id].weight),
          repetition: parseInt(referenceCopy[association.exercise_id].repetition),
        });
      }

      try{
        if(await postModel(routes.EXERCISE_REFERENCES_POST_API, data)) {
          const exercise_reference = {...referenceCopy};

          this.setState({
            onUpdateStudentReference: false,
            confirmInProgress: false,
            studentOverlayOriginalReferenceData: {...referenceCopy},
            training_data: {...this.state.training_data, exercise_reference}
          });
        }
      }
      catch(errors) {
        let errorDescription = DEFAULT_UNKNOWN_ERROR_MESSAGE;

        if(errors instanceof Array) {
          for(let error of errors) {
            switch (error.code) {
              // case 104:
              //   for(let parameter of error.parameters) {
              //     switch (parameter.name) {
              //       case 'contracts':
              //         errorDescription = 'Serviço vinculado à um contrato de aluno. Estes contratos devem ser excluídos antes de excluir este serviço.';
              //
              //         break;
              //       default:
              //     }
              //   }
              //
              //   break;
              case 209:
                errorDescription = 'Sessão do usuário expirada.';

                break;
              default:
            }
          }
        }

        this.setState({
          confirmFailDescription: errorDescription,
          confirmFailed: true,
          confirmInProgress: false
        });

        return;
      }
    }

    return;
  }

  getPrPercentage(physicalRecuperationStatus, currentPrPercentage) {
    return Math.round(currentPrPercentage - (10*(10 - physicalRecuperationStatus)/3));
  }

  handleReferenceChange(event) {
    const target = event.target;
    let value = target.value;
    const name = target.name;

    const referenceCopy = {...this.state.studentOverlayReferenceData};

    const exercise_associations = this.state.training_data.training_day.group_associations.flatMap((group) => group.exercise_associations);

    if(name.startsWith('exercise_reference:')) {
      const selection = name.split(':');
      const associationId = parseInt(selection[1]);

      const association = exercise_associations.find((association) => association.id === associationId);
      const exercise_id = association.exercise_id;

      if(!value) {
        value = null;
      }
      else {
        const prPercentage = this.getPrPercentage(10, association.difficult_value[0]);

        value = 100 * parseFloat(value) / prPercentage;
      }

      referenceCopy[exercise_id] = {...referenceCopy[exercise_id]};

      referenceCopy[exercise_id].value = value;
    }
    else if(name.startsWith('exercise_reference_input:')) {
      const selection = name.split(':');
      const associationId = parseInt(selection[1]);
      const parameterName = selection[2];

      const association = exercise_associations.find((association) => association.id === associationId);
      const exercise_id = association.exercise_id;

      referenceCopy[exercise_id] = {...referenceCopy[exercise_id]};

      referenceCopy[exercise_id][parameterName] = value || null;

      if(referenceCopy[exercise_id].weight && referenceCopy[exercise_id].repetition) {
        referenceCopy[exercise_id].value = (referenceCopy[exercise_id].weight * 100) / (102.78 - (2.78 * referenceCopy[exercise_id].repetition));
      }
    }

    this.setState({
      studentOverlayReferenceData: referenceCopy
    });
  }

  render() {
    if(this.state.loading) {
      return (
        <PoseGroup>
          <FadeContainer key="preloader">
            <PreLoader />
          </FadeContainer>
        </PoseGroup>
      );
    }

    let minutes = '';
    let seconds = '';

    if(this.state.training_data.total_seconds) {
      minutes = Math.floor(this.state.training_data.total_seconds / 60);
      seconds = this.state.training_data.total_seconds % 60;
    }

    let workoutMinutes = '';
    let workoutSeconds = '';

    if(this.state.training_data.workout_time) {
      workoutMinutes = Math.floor(this.state.training_data.workout_time / 60);
      workoutSeconds = this.state.training_data.workout_time % 60;
    }

    return (
      <React.Fragment>

        <DefaultMenuLayout
          showBackButton={true}
          history={this.props.history}
          onLogout={() => this.props.onLogout()}
          username={this.props.username}
          system_name={this.props.system_name}
          system_logo_url={this.props.system_logo_url}
          system_primary_color={this.props.system_primary_color}
          system_primary_contrast_color={this.props.system_primary_contrast_color}
          system_secondary_color={this.props.system_secondary_color}
          system_secondary_contrast_color={this.props.system_secondary_contrast_color}
        >

          <div className="personal-training-edit">

            <section className="personal-training-edit__data">

              <header className="personal-training-edit__data__header">

              <h3 className="personal-training-edit__data__header__title">
                <i className="fas fa-edit"></i>
                {' '}Editar treino de personal
              </h3>

              </header>

              <div className="personal-training-edit__data__content">

                {this.state.prExerciseAssociations.length > 0 &&
                  <React.Fragment>

                    <div className="personal-training-edit__additional-actions">

                      <DefaultMenuButton
                        className="personal-training-edit__pr-button"
                        onClick={() => this.onShowStudentPr()}
                        text="Recorde Pessoal (PR)"
                      />

                    </div>

                    <HorizontalRule />

                  </React.Fragment>
                }

                <div className="personal-training-edit__warning-container">

                  <WarningMessage
                    message={this.state.warningMessage}
                    onClose={() => {this.setState({highlights: [], showWarningMessage: false})}}
                    visible={this.state.showWarningMessage}
                  />

                </div>

                <div className="personal-training-edit__input-container">

                  <DefaultInput
                    className="personal-training-edit__input--normal"
                    name="date"
                    label="Data de execução:"
                    type="date"
                    placeholder="Data de execução"
                    handleInputChange={(event) => this.handleInputChange(event)}
                    value={this.state.training_data.date}
                    autoComplete="off"
                  />

                  <HalfWrapper>

                    <DefaultInput
                      className="personal-training-edit__input--normal"
                      name="difficulty"
                      isHighlighted={this.isHighlighted("difficulty")}
                      label="Dificuldade:"
                      type="select"
                      handleInputChange={(event) => this.handleInputChange(event)}
                      value={this.state.training_data.difficulty || ''}
                      options={this.getDifficultyOptions()}
                    />

                    <DefaultInput
                      className="personal-training-edit__input--rounded-left"
                      name="total_repetitions"
                      label="Repetições:"
                      type="number"
                      placeholder="-"
                      min="0"
                      step="1"
                      handleInputChange={(event) => this.handleInputChange(event)}
                      value={this.state.training_data.total_repetitions || ''}
                      autoComplete="off"
                      suffix="reps"
                      onFocus={(event) => event.target.select()}
                    />

                  </HalfWrapper>

                  <HalfWrapper>

                    <DefaultInput
                      className="personal-training-edit__input--rounded-left"
                      name="minutes"
                      label="Tempo total:"
                      type="number"
                      placeholder="-"
                      min="0"
                      step="1"
                      handleInputChange={(event) => this.handleInputChange(event)}
                      value={minutes}
                      autoComplete="off"
                      suffix={this.state.screenWidth > 680 ? 'minutos' : 'min'}
                      onFocus={(event) => event.target.select()}
                    />

                    <DefaultInput
                      className="personal-training-edit__input--rounded-left personal-training-edit__seconds-input"
                      name="seconds"
                      type="number"
                      placeholder="-"
                      min="0"
                      step="1"
                      handleInputChange={(event) => this.handleInputChange(event)}
                      value={seconds}
                      autoComplete="off"
                      suffix={this.state.screenWidth > 680 ? 'segundos' : 'seg'}
                      onFocus={(event) => event.target.select()}
                    />

                  </HalfWrapper>

                  <HalfWrapper>

                    <DefaultInput
                      className="personal-training-edit__input--rounded-left"
                      name="workoutMinutes"
                      label="Tempo do workout:"
                      type="number"
                      placeholder="-"
                      min="0"
                      step="1"
                      handleInputChange={(event) => this.handleInputChange(event)}
                      value={workoutMinutes}
                      autoComplete="off"
                      suffix={this.state.screenWidth > 680 ? 'minutos' : 'min'}
                      onFocus={(event) => event.target.select()}
                    />

                    <DefaultInput
                      className="personal-training-edit__input--rounded-left personal-training-edit__seconds-input"
                      name="workoutSeconds"
                      type="number"
                      placeholder="-"
                      min="0"
                      step="1"
                      handleInputChange={(event) => this.handleInputChange(event)}
                      value={workoutSeconds}
                      autoComplete="off"
                      suffix={this.state.screenWidth > 680 ? 'segundos' : 'seg'}
                      onFocus={(event) => event.target.select()}
                    />

                  </HalfWrapper>

                  <DefaultInput
                    className="personal-training-edit__input--rounded-left"
                    name="total_weight"
                    label="Kilagem média total:"
                    type="number"
                    placeholder="-"
                    min="0"
                    step="0.1"
                    handleInputChange={(event) => this.handleInputChange(event)}
                    value={this.state.training_data.total_weight || ''}
                    autoComplete="off"
                    suffix="kg"
                    onFocus={(event) => event.target.select()}
                  />

                  <div className="personal-training-edit__input-wrapper--vertical">

                    <h4 className="personal-training-edit__input-label">PSE - O quão pesado foi seu treino?</h4>

                    <div className="personal-training-edit__notification-container">

                      <i className="fas fa-exclamation personal-training-edit__notification-container__icon"></i>

                      <p className="personal-training-edit__notification-container__text">

                        O preenchimento da PSE deve ser feito cerca de 20-30 minutos após o fim da atividade física para
                        utilizar nossa metodologia de análise de carga de forma precisa.

                      </p>

                    </div>

                    <ul className="personal-training-edit__scale">

                      <li className="personal-training-edit__scale__group">

                        <div className="personal-training-edit__scale__group__image--2">

                          <i className="fas fa-kiss-beam personal-training-edit__scale__group__image-icon"></i>

                        </div>

                        <div className="personal-training-edit__scale__group__options">

                          <button
                            className="personal-training-edit__scale__group__option--1"
                            onClick={() => this.onSetPse(1)}
                            disabled={this.state.training_data.pse === 1}
                          >

                            <p className="personal-training-edit__scale__group__option-number">
                              1
                            </p>

                            {/* <p className="personal-training-edit__scale__group__option-text--flex">
                              Muito leve
                            </p> */}

                          </button>

                          <button
                            className="personal-training-edit__scale__group__option--2"
                            onClick={() => this.onSetPse(2)}
                            disabled={this.state.training_data.pse === 2}
                          >

                            <p className="personal-training-edit__scale__group__option-number">
                              2
                            </p>

                            {/* <p className="personal-training-edit__scale__group__option-text--flex">
                              Leve
                            </p> */}

                          </button>

                        </div>

                        <div className="personal-training-edit__scale__group__description--2">

                          <p className="personal-training-edit__scale__group__description__text">
                            Muito leve
                          </p>

                        </div>

                      </li>

                      <li className="personal-training-edit__scale__group">

                        <div className="personal-training-edit__scale__group__image--4">

                          <i className="fas fa-grin personal-training-edit__scale__group__image-icon"></i>

                        </div>

                        <div className="personal-training-edit__scale__group__options">

                          <button
                            className="personal-training-edit__scale__group__option--3"
                            onClick={() => this.onSetPse(3)}
                            disabled={this.state.training_data.pse === 3}
                          >

                            <p className="personal-training-edit__scale__group__option-number">
                              3
                            </p>

                            {/* <p className="personal-training-edit__scale__group__option-text--flex">
                              Tranquilo
                            </p> */}

                          </button>

                          <button
                            className="personal-training-edit__scale__group__option--4"
                            onClick={() => this.onSetPse(4)}
                            disabled={this.state.training_data.pse === 4}
                          >

                            <p className="personal-training-edit__scale__group__option-number">
                              4
                            </p>

                            {/* <p className="personal-training-edit__scale__group__option-text--flex">
                              Moderado
                            </p> */}

                          </button>

                        </div>

                        <div className="personal-training-edit__scale__group__description--4">

                          <p className="personal-training-edit__scale__group__description__text">
                            Leve
                          </p>

                        </div>

                      </li>

                      <li className="personal-training-edit__scale__group">

                        <div className="personal-training-edit__scale__group__image--6">

                          <i className="fas fa-meh personal-training-edit__scale__group__image-icon"></i>

                        </div>

                        <div className="personal-training-edit__scale__group__options">

                          <button
                            className="personal-training-edit__scale__group__option--5"
                            onClick={() => this.onSetPse(5)}
                            disabled={this.state.training_data.pse === 5}
                          >

                            <p className="personal-training-edit__scale__group__option-number">
                              5
                            </p>

                            {/* <p className="personal-training-edit__scale__group__option-text--flex">
                              Requer esforço
                            </p> */}

                          </button>

                          <button
                            className="personal-training-edit__scale__group__option--6"
                            onClick={() => this.onSetPse(6)}
                            disabled={this.state.training_data.pse === 6}
                          >

                            <p className="personal-training-edit__scale__group__option-number">
                              6
                            </p>

                            {/* <p className="personal-training-edit__scale__group__option-text--flex">
                              Pouco pesado
                            </p> */}

                          </button>

                        </div>

                        <div className="personal-training-edit__scale__group__description--6">

                          <p className="personal-training-edit__scale__group__description__text">
                            Moderado
                          </p>

                        </div>

                      </li>

                      <li className="personal-training-edit__scale__group">

                        <div className="personal-training-edit__scale__group__image--8">

                          <i className="fas fa-frown-open personal-training-edit__scale__group__image-icon"></i>

                        </div>

                        <div className="personal-training-edit__scale__group__options">

                          <button
                            className="personal-training-edit__scale__group__option--7"
                            onClick={() => this.onSetPse(7)}
                            disabled={this.state.training_data.pse === 7}
                          >

                            <p className="personal-training-edit__scale__group__option-number">
                              7
                            </p>

                            {/* <p className="personal-training-edit__scale__group__option-text--flex">
                              Pesado
                            </p> */}

                          </button>

                          <button
                            className="personal-training-edit__scale__group__option--8"
                            onClick={() => this.onSetPse(8)}
                            disabled={this.state.training_data.pse === 8}
                          >

                            <p className="personal-training-edit__scale__group__option-number">
                              8
                            </p>

                            {/* <p className="personal-training-edit__scale__group__option-text--flex">
                              Muito pesado
                            </p> */}

                          </button>

                        </div>

                        <div className="personal-training-edit__scale__group__description--8">

                          <p className="personal-training-edit__scale__group__description__text">
                            Pesado
                          </p>

                        </div>

                      </li>

                      <li className="personal-training-edit__scale__group">

                        <div className="personal-training-edit__scale__group__image--10">

                          <i className="fas fa-tired personal-training-edit__scale__group__image-icon"></i>

                        </div>

                        <div className="personal-training-edit__scale__group__options">

                          <button
                            className="personal-training-edit__scale__group__option--9"
                            onClick={() => this.onSetPse(9)}
                            disabled={this.state.training_data.pse === 9}
                          >

                            <p className="personal-training-edit__scale__group__option-number">
                              9
                            </p>

                            {/* <p className="personal-training-edit__scale__group__option-text--flex">
                              Extremamente pesado
                            </p> */}

                          </button>

                          <button
                            className="personal-training-edit__scale__group__option--10"
                            onClick={() => this.onSetPse(10)}
                            disabled={this.state.training_data.pse === 10}
                          >

                            <p className="personal-training-edit__scale__group__option-number">
                              10
                            </p>

                            {/* <p className="personal-training-edit__scale__group__option-text--flex">
                              Quase impossível
                            </p> */}

                          </button>

                        </div>

                        <div className="personal-training-edit__scale__group__description--10">

                          <p className="personal-training-edit__scale__group__description__text">
                            Muito pesado
                          </p>

                        </div>

                      </li>

                    </ul>

                    <p className="personal-training-edit__small-note">

                      *A PSE é uma estimativa para quantificar o esforço físico necessário para realizar a atividade
                      proposta e está diretamente relacionada com o cansaço físico persistente depois de sua execução.

                    </p>

                  </div>

                </div>

                <HorizontalRule />

                <div className="personal-training-edit__buttons-container">

                  <DefaultMenuButton
                    className="personal-training-edit__save-button"
                    disabled={!this.inputsAreValid()}
                    onClick={() => this.saveData()}
                    text="Salvar"
                    color="blue"
                  />

                  <DefaultMenuButton
                    className="personal-training-edit__cancel-button"
                    onClick={() => this.props.history.goBack()}
                    text="Cancelar"
                  />

                </div>

              </div>

            </section>

          </div>

        </DefaultMenuLayout>

        {this.hasSupportTable() &&
          <aside className={`personal-training-edit__support-table${this.state.supportTableVisible ? '--visible' : ''}`}>

            <div className="personal-training-edit__support-table__controls">

              <DefaultMenuButton
                className="personal-training-edit__support-table__toggle-button"
                onClick={() => this.setState({supportTableVisible: !this.state.supportTableVisible})}
                text={(<i className="fas fa-chevron-down"></i>)}
                color="red"
              />

            </div>

            <header className="personal-training-edit__support-table__header">

              <div className="personal-training-edit__support-table__header__title-wrapper">

                <h2 className="personal-training-edit__support-table__header__title">

                  Tabela auxiliar

                </h2>

              </div>

            </header>

            <div className="personal-training-edit__support-table__content">

              {this.getSupportTables()}

            </div>

          </aside>
        }

        <OverlayWindow
          className="personal-training-edit__overlay"
          visible={this.state.showStudentPr}
          loading={false}
          actions={(
            <div className="personal-training-edit__overlay__action-container">

              {this.getStudentOverlayActions()}

            </div>
          )}
        >

          <header className="personal-training-edit__overlay__header">

            <h3 className="personal-training-edit__overlay__header__title">
              {this.state.studentOverlayShowInputs ? 'Definição de PR' : 'Referências de peso'}
            </h3>

            <DefaultMenuButton
              className="personal-training-edit__overlay__header__toggle-button"
              onClick={() => this.setState({
                studentOverlayShowInputs: !this.state.studentOverlayShowInputs
              })}
              text={(<i className="fas fa-exchange-alt"></i>)}
            />

          </header>

          <hr className="personal-training-edit__horizontal-rule" />

          <div className="personal-training-edit__overlay__reference-container">

            {this.getStudentOverlayData()}

          </div>

        </OverlayWindow>

        <ConfirmationWindow
          title={this.getConfirmationWindowTitle()}
          description={this.getConfirmationWindowDescription()}
          confirmText={this.getConfirmationWindowConfirmButtonText()}
          cancelText={this.state.confirmFailed ? 'Ok' : 'Cancelar'}
          visible={this.confirmationWindowIsVisible()}
          onCancel={() => this.resetConfirmationWindow()}
          onConfirm={() => this.proceedConfirmationWindow()}
          loading={this.state.confirmInProgress}
          useErrorIcon={this.state.confirmFailed}
          hideConfirmButton={this.state.confirmFailed}
        />

      </React.Fragment>
    );
  }
}

export default PersonalTrainingEdit;
